export const fmtPriceShort = (p) => {
  const n = Number(p) || 0;
  if (!n) return '';
  if (n >= 1e6) return `$${+(n / 1e6).toFixed(2)}M`;
  return `$${+(n / 1e3).toFixed(1)}k`;
};

export const galleryUrl = (token) => `${window.location.origin}/api/f/${token}`;

export function buildFlyerText(f, token) {
  const num = v => Number(v) || 0;
  const addr = [f.property_address, f.property_city, [f.property_state || 'FL', f.property_zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  const lines = [];
  if (f.area_tag) lines.push(`🔥 ${f.area_tag.replace(/!+$/, '').toUpperCase()}! 🔥`);
  if (f.headline) lines.push(f.headline);
  if (addr) lines.push(`📍 ${addr}`);
  if (num(f.asking_price)) lines.push(`💰 Asking Price: ${fmtPriceShort(f.asking_price)}`);
  const bullets = [];
  if (num(f.beds) || num(f.baths)) bullets.push([num(f.beds) && `${num(f.beds)} Bedrooms`, num(f.baths) && `${num(f.baths)} Bathrooms`].filter(Boolean).join(' / '));
  if (num(f.sqft)) bullets.push(`${num(f.sqft).toLocaleString()} Sq. Ft. Living Area`);
  if (num(f.lot_sqft)) bullets.push(`Approximately ${num(f.lot_sqft).toLocaleString()} Sq. Ft. Lot (${(num(f.lot_sqft) / 43560).toFixed(2)} Acre)`);
  (f.highlights || []).filter(h => h.trim()).forEach(h => bullets.push(h.trim()));
  if (bullets.length) { lines.push('🏡 PROPERTY HIGHLIGHTS'); bullets.forEach(b => lines.push(`✅ ${b}`)); }
  if (f.contact_name || f.contact_phone) { lines.push('For showings please call or Text'); lines.push([f.contact_name, f.contact_phone].filter(Boolean).join(' ')); }
  if (token && f.photo_count) lines.push(`📸 Photos: ${galleryUrl(token)}`);
  return lines.join('\n');
}

export async function compressImage(file, max = 1600) {
  const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = URL.createObjectURL(file); });
  const scale = Math.min(1, max / Math.max(img.width, img.height));
  const c = document.createElement('canvas');
  c.width = Math.round(img.width * scale); c.height = Math.round(img.height * scale);
  c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
  URL.revokeObjectURL(img.src);
  return new Promise(res => c.toBlob(b => res(new File([b], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' })), 'image/jpeg', 0.85));
}

export async function copyText(text) {
  try { await navigator.clipboard.writeText(text); return true; } catch {
    const t = document.createElement('textarea'); t.value = text; document.body.appendChild(t); t.select();
    const ok = document.execCommand('copy'); t.remove(); return ok;
  }
}

export async function copyImage(url) {
  const png = (async () => {
    const img = await createImageBitmap(await (await fetch(url)).blob());
    const c = document.createElement('canvas'); c.width = img.width; c.height = img.height;
    c.getContext('2d').drawImage(img, 0, 0);
    return new Promise(r => c.toBlob(r, 'image/png'));
  })();
  await navigator.clipboard.write([new window.ClipboardItem({ 'image/png': png })]);
}

export async function downloadAll(photos, base = 'property') {
  for (let i = 0; i < photos.length; i++) {
    const blob = await (await fetch(`/api/fp/${photos[i].id}`)).blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = `${base.replace(/[^\w-]+/g, '_')}_${i + 1}.jpg`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
    await new Promise(r => setTimeout(r, 250));
  }
}
